import React, { useContext } from 'react'
import { Link } from 'react-router-dom'
import { LanguageContext } from '../LanguageSwitcher/LanguageContext'
import './articleNav.scss'

export const ArticleBackLink = () => {
  const { translations } = useContext(LanguageContext)

  return (
    <Link className='article-back-link' to='/articles'>
      <span className='article-back-link-arrow'>←</span> {translations.Blog}
    </Link>
  )
}

export const ArticleNextCta = ({ link, title }) => {
  const { translations } = useContext(LanguageContext)

  return (
    <Link className='article-next-cta' to={link}>
      <div className='article-next-cta-info'>
        <p className='article-next-cta-label'>{translations.nextArticle}</p>
        <p className='article-next-cta-title'>{title}</p>
      </div>
      <span className='article-next-cta-arrow'>→</span>
    </Link>
  )
}
